import React from 'react';

import Header from '../partials/Header';
import HeroExodon from '../partials/HeroExodon';
import ExodonComponent from '../partials/ExodonComponent';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function Hepatus() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">

        {/*  Page sections */}
        <HeroExodon />
        <ExodonComponent />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Hepatus;